import { render, staticRenderFns } from "./Dosage.vue?vue&type=template&id=6f260f44&scoped=true&"
import script from "./Dosage.vue?vue&type=script&lang=js&"
export * from "./Dosage.vue?vue&type=script&lang=js&"
import style0 from "./Dosage.vue?vue&type=style&index=0&id=6f260f44&lang=scss&scoped=true&"
import style1 from "./Dosage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f260f44",
  null
  
)

export default component.exports